import React from "react";

export const LazySecuritiesApiMultiSelectAutoUpdateBridge = React.lazy(
    () =>
        import(
            /* webpackChunkName: "SelectAutoUpdate" */ "./SecuritiesApiMultiSelectAutoUpdate"
        )
);
